import * as React from 'react';
import './label.scss';

export interface LabelProps {
  type?: 'basic' | 'green' | 'blue' | 'blue-light' | 'red' | 'black-outline';
  caps?: boolean;
  children: React.ReactNode;
  onClick?(): void;
  style?: React.CSSProperties;
}

const Label: React.FC<LabelProps> = ({ type = 'basic', caps = false, children, onClick, style }) => {
  return (
    <div
      className={'status-label status-label--' + type + (caps ? ' status-label--caps' : '')}
      onClick={onClick}
      style={style}
    >
      {children}
    </div>
  );
};

export default Label;
